import { useMemo, useState } from "react";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";

const DAY_OF_WEEK_NAMES = [
	"\uC77C",
	"\uC6D4",
	"\uD654",
	"\uC218",
	"\uBAA9",
	"\uAE08",
	"\uD1A0",
] as const;

interface Props {
	analysisDt: string;
	onAnalysisDtChange: (value: Date | undefined) => void;
}

const toDate = (value: string): Date | undefined => {
	if (!value) return undefined;
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return undefined;
	return date;
};

export const Info_TQC2080_R01 = ({ analysisDt, onAnalysisDtChange }: Props) => {
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPos, setPickerPos] = useState({ top: 0, left: 0, height: 0 });

	const selectedDate = useMemo(() => toDate(analysisDt), [analysisDt]);
	const dayOfWeekText = useMemo(() => {
		if (!selectedDate) return "-";
		return DAY_OF_WEEK_NAMES[selectedDate.getDay()];
	}, [selectedDate]);

	return (
		<div className="w-full border border-gray-300 px-[12px] py-[6px] mb-[4px] flex items-center gap-[12px]">
			<SingleDateForm
				title="일자"
				value={selectedDate}
				setValue={onAnalysisDtChange}
				editable={true}
				visible={pickerVisible}
				setVisible={setPickerVisible}
				pickerPos={pickerPos}
				setPickerPos={setPickerPos}
				wrapperOption={{
					wrapperStyle: "w-[260px] min-w-[260px] mr-[0px] mb-[0px]",
					titleStyle: "w-[70px] min-w-[70px] text-left",
					inputStyle: "w-[180px] min-w-[180px]",
				}}
			/>
			<p className="text-[12px] text-gray-600">
				{"요일"}: {dayOfWeekText}
			</p>
		</div>
	);
};
